(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gelvamel-product-custom"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gelvamel-product-form')) {
    customElements.define('gelvamel-product-form', class extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('.gv-product__variant-select');
        if (!select) return;
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          const form = select.closest('form');
          const price = form.querySelector('[data-product-price]');
          const compare = form.querySelector('[data-compare-price]');
          const sku = form.querySelector('[data-product-sku]');
          const button = form.querySelector('.gv-product__add');
          const available = option.dataset.available === 'true';
          if (price) price.textContent = option.dataset.price || '';
          if (compare) {
            compare.textContent = option.dataset.comparePrice || '';
            compare.hidden = !option.dataset.comparePrice;
          }
          if (sku) sku.textContent = option.dataset.sku || '';
          if (button) {
            button.disabled = !available;
            button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
